import { LOGIN_AS_TOKEN_KEY } from 'app/services/jwtService';

export const isLoggedInAsAdmin = (): boolean => {
  return !!localStorage.getItem(LOGIN_AS_TOKEN_KEY);
};
